import * as React from 'react';
import { XStack } from 'tamagui';

import { BodyMediumRegular, BodySmallRegular } from '../text/Typography';

/**
 * ExpandingTile - A compact tile that expands into a SheetDialog when pressed
 * Button variant shows a number indicator and title
 */
export interface ExpandingTileProps {
    title: string;
    numberIndicator?: string | number;
    indicatorColor?: string;
    onPress: () => void;
}

export const ExpandingTile = ({
    title,
    numberIndicator,
    indicatorColor = '$green300',
    onPress,
}: ExpandingTileProps) => {
    return (
        <XStack
            height={72}
            width="100%"
            backgroundColor="$white"
            borderRadius={24}
            paddingHorizontal={24}
            alignItems="center"
            justifyContent="center"
            position="relative"
            pressStyle={{ opacity: 0.8 }}
            onPress={onPress}
            shadowColor="$black"
            shadowOpacity={0.06}
            shadowOffset={{ width: 0, height: 8 }}
            shadowRadius={16}
        >
            {numberIndicator != null && (
                <XStack
                    position="absolute"
                    left={24}
                    backgroundColor={indicatorColor}
                    width={32}
                    height={32}
                    borderRadius={16}
                    alignItems="center"
                    justifyContent="center"
                >
                    <BodySmallRegular textAlign="center">
                        {numberIndicator}
                    </BodySmallRegular>
                </XStack>
            )}
            <BodyMediumRegular textAlign="center">{title}</BodyMediumRegular>
        </XStack>
    );
};
